import { SIZES } from 'shared/components/Avatar';

export const userInfo = {
  maxWidth: 'auto',
  pictureSize: SIZES.MD,
};
